import { render, staticRenderFns } from "./MessageNew.vue?vue&type=template&id=650debe9&scoped=true&"
import script from "./MessageNew.vue?vue&type=script&lang=js&"
export * from "./MessageNew.vue?vue&type=script&lang=js&"
import style0 from "./MessageNew.vue?vue&type=style&index=0&id=650debe9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650debe9",
  null
  
)

export default component.exports